export interface SkillResponse {
	id: string;
	companyDomainId: string;
	createdByUserId: string;
	name: string;
	description: string;
	instructions: string;
	isEnabled: boolean;
	anthropicSkillId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface CreateSkillRequest {
	companyDomainId: string;
	name: string;
	description: string;
	instructions: string;
}

export interface UpdateSkillRequest {
	companyDomainId: string;
	skillId: string;
	name?: string;
	description?: string;
	instructions?: string;
	isEnabled?: boolean;
}

export interface GenerateSkillRequest {
	companyDomainId: string;
	prompt: string;
	currentDraft?: {
		name: string;
		description: string;
		instructions: string;
	};
}

export interface GenerateSkillResponse {
	name: string;
	description: string;
	instructions: string;
}

export interface ParseUploadResponse {
	name: string;
	description: string;
	instructions: string;
}

// Validation constants
export const SKILL_NAME_PATTERN = /^[a-z0-9-]+$/;
export const SKILL_NAME_MAX = 64;
export const SKILL_DESCRIPTION_MAX = 1024;
export const SKILL_INSTRUCTIONS_MAX = 50_000;
export const FORBIDDEN_NAME_WORDS = ["anthropic", "claude"];
export const XML_TAG_PATTERN = /<\/?[a-zA-Z][^>]*>/;
export const MAX_SKILLS = 50;
